import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text"]
  static values = { text: String }

  copy() {
    const textToCopy = this.hasTextValue ? this.textValue : this.textTarget.textContent
    
    navigator.clipboard.writeText(textToCopy).then(() => {
      // Add copied class for CSS transitions
      this.element.classList.add("copied")
      
      // Remove after 2 seconds
      setTimeout(() => {
        this.element.classList.remove("copied")
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy: ', err)
    })
  }
}